"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OdataPrimitive = exports.OdataModel = void 0;
class OdataModel {
    constructor(modelType, ...parts) {
        this.modelType = modelType;
        Object.assign(this, { value: [] }, ...parts);
        this.value = this.value.map((i) => i instanceof modelType ? i : new modelType(i));
    }
}
exports.OdataModel = OdataModel;
class OdataPrimitive {
    constructor(...parts) {
        Object.assign(this, ...parts);
    }
}
exports.OdataPrimitive = OdataPrimitive;
